export const enviarcheckin = {
    text1: "إرسال تسجيل الوصول",
    text2: "أرسل رابطًا لنزلائك لتسجيل الوصول قبل وصولهم إلى وحدة الإقامة.",
    text3: "اختر وحدة الإقامة *",
    text4: "أدخِل الاسم",
    text5: "اسم النزيل *",
    text6: "رقم هاتف النزيل *",
    text7: "البريد الإلكتروني",
    text8: "البريد الإلكتروني للنزيل *",
    text9: "إرسال",
    text09: "جدولة",
    text10: "جارٍ إرسال تسجيل الوصول، يرجى الانتظار",
    text11: "عليك اختيار وحدة إقامة لإسناد تسجيل الوصول إليها",
    text12: "حقل الاسم مطلوب",
    text13: "حقل الهاتف مطلوب",
    text14: "البريد الإلكتروني مطلوب",
    text15: "أوشكنا على الانتهاء",
    text16: "مرحبًا ",
    text17: "! نحن ",
    text18: ". نرسل لك هذه الرسالة لتتمكّن من تسجيل الوصول قبل وصولك إلى وحدة إقامتنا، فتتجنّب الانتظار المحتمل في الاستقبال، وقبل كل شيء استهلاك الورق دون داعٍ. \n\nمن أجل كوكب أكثر خضرة!",
    text19: "مرحبًا ",
    text20: "! نحن ",
    text21: ". نرسل لك هذه الرسالة لتتمكّن من تسجيل الوصول قبل وصولك إلى وحدة إقامتنا، فتتجنّب الانتظار المحتمل في الاستقبال، وقبل كل شيء استهلاك الورق دون داعٍ. <br> <br> من أجل كوكب أكثر خضرة!",
    text22: "تم إرسال تسجيل الوصول بنجاح",
    text23: "جارٍ التحميل ...",

    // Corrections
    p1: "إرسال رابط تسجيل الوصول",
    p2: "إنشاء حجز",
    p3: "معلومات الحجز",
    p4: "اسم النزيل المسؤول",
    p5: "تاريخ تسجيل الوصول",
    p6: "تاريخ تسجيل المغادرة",
    p7: "عدد النزلاء",
    p8: "اختر غرفة",
    p9: "غير محدّد",
    p10: "اختر رقم الغرفة",
    p11: "تسجيل الوصول عبر الإنترنت",
    p12: "سعر الحجز",
    p13: "إنشاء حجز",
    p14:`والآن ادعُ نزيلك لمتابعة تسجيل الوصول.`,
    p15:`رسوم إضافية`,

    p16:`حدّد الغرفة`,
    p17:`إذا اخترت غرفة، فسنرسل المفاتيح المرتبطة بها`,
    p18:`اختر الغرفة`,
    p19:`لا توجد نتائج. جرّب مصطلحًا آخر.`,
    p20:`لا توجد غرف متاحة.`,
    p21:`اضغط Enter للاختيار`,
    p22:`محدَّد`,
    p23:`اضغط Enter للإزالة`,
    p24:`لا توجد خيارات متاحة`,
    p25: `تم إنشاء الحجز بنجاح.`,
    p26: `اكتمل الحجز بنجاح. يمكنك العودة إلى الصفحة الرئيسية.`,
    p27: `تم إرسال الدعوة بنجاح.`,
    p28: `موافق`,
};
